import ModalPlaceholder from './modal-placeholder';
export default ModalPlaceholder;